import { observer } from "mobx-react-lite";
import React from "react";
import Individuality from "./Individuality";
import Responasbility from "./Responasbility";
import Earning from "./Earning";
import Team from "./Team";

function About2() {
  return (
    <>
      <div className="row g-4">
        <div className="col-12 col-md-5">
          <Individuality />
        </div>
        <div className="col-12 col-md-7">
          <Responasbility />
        </div>
        <div className="col-12 col-md-6">
          <Earning />
        </div>
        <div className="col-12 col-md-6">
          <Team />
        </div>
      </div>
    </>
  );
}

export default observer(About2);
